import { call } from "redux-saga/effects";
import { API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* addExperienceRating(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.EXPERIENCE_RATING.ADD, action.payload, true);
}

export function* getExperienceRating(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.EXPERIENCE_RATING.GET, action.payload, true);
}

export function* updateExperienceRating(action: any): any {
  yield call(sagaFunction, action, CallApi.PUT, API_URL.EXPERIENCE_RATING.UPDATE, action.payload, true);
}
